// src/Table.js
import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import {
  useTable,
  useFilters,
  useGlobalFilter,
  useSortBy,
  usePagination,
} from "react-table";
// import { CSVLink, CSVDownload } from "react-csv";
import "./Table.css";

import { ClipLoader } from "react-spinners";

// src/data.js

// Function to handle opening the Modal

const Table = ({ columns, data, name, filename, loading }) =>
  // data

  {
    const navigate = useNavigate();

    // Define the columns for the table

    // Function to handle closing the Modal

    // Create a table instance using the useTable hook
    const {
      getTableProps,
      getTableBodyProps,
      headerGroups,
      rows,
      nextPage,
      page,
      canNextPage,
      canPreviousPage,
      previousPage,
      state,
      gotoPage,
      setPageSize,
      pageCount,
      setGlobalFilter,
      prepareRow,
    } = useTable(
      { columns, data },

      useFilters,
      useGlobalFilter,
      useSortBy,
      usePagination
    );
    const { pageIndex, pageSize, globalFilter } = state;
    const handleNext = () => {
      nextPage();
    };

    const handlePrev = () => {
      previousPage();
    };

    const handleChangePageSize = (e) => {
      Number(setPageSize(e.target.value));
    };

    const oddRowClass = "bg-[#F0EFEF]";
    const evenRowClass = "bg-white";

    // const HandleExport = ({ name }) => {
    //   // const filename = `data_page_size_${pageSize}.csv`; // Dynamic filename based on page size
    //   return (
    //     <CSVLink data={data} filename={filename}>
    //       {name}
    //     </CSVLink>
    //   );
    // };

    function getDataForExport() {
      return rows?.map((row) =>
        row?.cells?.map((cell) => {
          return cell?.render("Cell");
        })
      );
    }

    return (
      <div>
        <div className="overflow-x-auto pb-[2%] mt-[20px] shadow rounded-lg w-[100%] md:w-[100%]  mx-auto  md:mx-auto bg-white">
          <h1 className="fs-5 m-4">Signatories</h1>
          <div>
            {data?.length > 0 ? (
              <table
                className="rounded w-[100%] h-[80%] mt-[20px] pl-[10px]"
                {...getTableProps()}
              >
                <thead className=" border-b-2 text-left pl-2 font-medium text-sm">
                  {headerGroups?.map((headerGroup) => (
                    <tr
                      className="p-[20%]"
                      {...headerGroup.getHeaderGroupProps()}
                    >
                      {headerGroup.headers.map((column) => (
                        <th
                          {...column.getHeaderProps()}
                          style={{ padding: "18px" }}
                        >
                          {column.render("Header")}
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>

                <tbody className=" px-0 text-[13px]" {...getTableBodyProps()}>
                  {page.map((row, index) => {
                    prepareRow(row);
                    return (
                      <tr
                        className={`justify-center align-center border-b-2  hover:bg-gray-100 ${
                          index % 2 === 0 ? evenRowClass : oddRowClass
                        }`}
                        // className='text-center border-b-2 h-25 px-[10%]  hover:bg-gray-100'

                        {...row.getRowProps()}
                      >
                        {row.cells?.map((cell) => (
                          <td
                            className="w-[10%] "
                            {...cell.getCellProps()}
                            style={{ padding: "12px" }}
                          >
                            {cell.render("Cell")}
                          </td>
                        ))}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            ) : (
              <p className="text-sm text-center font-semibold mx-auto w-[50%] ">
                {" "}
                No Signatory added yet
              </p>
            )}
            <div className=" p-4 flex gap-3 md:gap-6">
              <div>
                <p>
                  Page <strong>{pageIndex + 1}</strong> of{" "}
                  <strong>{pageCount}</strong>
                </p>
              </div>
              <div className="flex gap-2 wrap">
                <button
                  type="button"
                  className="font-bold text-blue-400 disabled:text-gray-400 disabled:cursor-not-allowed"
                  disabled={!canPreviousPage}
                  onClick={() => gotoPage(0)}
                >
                  First
                </button>
                <button
                  type="button"
                  onClick={handlePrev}
                  className="font-bold text-blue-400 disabled:text-gray-400 disabled:cursor-not-allowed"
                  disabled={!canPreviousPage}
                >
                  Previous
                </button>
                <button
                  type="button"
                  onClick={() => handleNext()}
                  className="font-bold text-blue-400 ml-2 disabled:text-gray-400 disabled:cursor-not-allowed"
                  disabled={!canNextPage}
                >
                  Next
                </button>
                <button
                  type="button"
                  className="font-bold text-blue-400 disabled:text-gray-400 disabled:cursor-not-allowed"
                  disabled={!canNextPage}
                  onClick={() => gotoPage(pageCount - 1)}
                >
                  Last
                </button>
                <div className="flex gap-2 items-center ml-3">
                  <span className="font-bold">Show</span>
                  <select
                    value={pageSize}
                    onChange={handleChangePageSize}
                    className="cursor-pointer px-6 py-1 border rounded-md border-gray-300"
                  >
                    {
                    [5, 10, 15, 20, 25, 30].map((val) => (
                      <option value={val} key={val} className="py-1">
                        {val}
                      </option>
                    ))
                    }
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

export default Table;
